import React from "react";
import {
  Box,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import {
  AssessmentIcon,
  AttachmentsIcon,
  CareGiverIcon,
  CareOverviewIcon,
  CareTeamIcon,
  GoalsIcon,
  InterventionsIcon,
  MedicationsIcon,
  ProblemsIcon,
  VersionHistoryIcon,
} from "../../../assets/constants";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// rgba(12, 128, 243, 0.20)

const StyledListItem = styled(ListItem)(({ theme }) => ({
  // "&.activeTab": {
  //   background: "rgba(0, 0, 0, 0.10)",
  //   "&:hover": {
  //     "& svg path": {
  //       stroke: "#fff !important",
  //     },
  //   },
  //   "&& .Mui-selected, && .Mui-selected:hover": {
  //     backgroundColor: "#0C80F3 !important",
  //     borderRadius: "8px !important",
  //     "&, & .MuiListItemIcon-root": {
  //       color: "#fff !important",
  //     },
  //   },
  // },
}));

const StyledListItemText = styled(ListItemText)(() => ({
  "& span": {
    fontSize: "1.5rem !important",
  },
  "&.activeColor": {
    color: "#fff !important",
  },
}));

const careWorkspaceItems = [
  {
    title: "Overall Plan Overview",
    icon: <CareOverviewIcon />,
    to: "overview",
    key: "overview",
  },
  {
    title: "Assessment",
    to: "assessment",
    key: "assessment",
    icon: <AssessmentIcon />,
  },

  {
    title: "Problems",
    icon: <ProblemsIcon />,
    to: "problems",
    key: "problems",
  },

  {
    title: "Goals",
    icon: <GoalsIcon />,
    to: "goals",
    key: "goals",
  },
  {
    title: "Interventions",
    icon: <InterventionsIcon />,
    to: "interventions",
    key: "interventions",
  },
  {
    title: "Medications",
    icon: <MedicationsIcon />,
    to: "medications",
    key: "medications",
  },
  {
    title: "Care team",
    icon: <CareTeamIcon />,
    to: "care-team",
    key: "care-team",
  },
  {
    title: "Caregiver & Social Context",
    icon: <CareGiverIcon />,
    to: "caregiver",
    key: "caregiver",
  },
  {
    title: "Version History",
    icon: <VersionHistoryIcon />,
    to: "version-history",
    key: "version-history",
  },
];

const CarePlanSideDrawer = () => {
  const { id: patientId } = useParams();
  const location = useLocation();

  const getPlanVersionsList = useSelector((state) => state.getPlanVersionsList);
  const { carePlanVersionsList } = getPlanVersionsList;

  const anyVersionApproved = carePlanVersionsList?.versions?.some(
    (item) => item?.status === "approved"
  );

  const visibleItems = careWorkspaceItems.filter((item) => {
    if (
      !anyVersionApproved &&
      ["overview", "version-history"].includes(item.key)
    ) {
      return false;
    }
    return true;
  });

  return (
    <Stack height="100%" bgcolor="#F9F9FA" padding="12px 16px" gap="4px">
      <List>
        <Stack gap="8px">
          {visibleItems?.map((item) => (
            <StyledListItem key={item.key} disablePadding>
              <ListItemButton
                disableRipple
                selected={
                  location.pathname ===
                  `/patient/${patientId}/care-plan-workspace/${item.to}`
                }
                LinkComponent={NavLink}
                to={`/patient/${patientId}/care-plan-workspace/${item.to}`}
                sx={{
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "rgba(12, 128, 243, 0.20)",
                    "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                      color: "#0C80F3",
                      "& svg path": {
                        stroke: "#0C80F3",
                      },
                    },
                  },
                  "&.Mui-selected, &.Mui-selected:hover": {
                    backgroundColor: "#0C80F3",
                    "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                      color: "#fff",
                      "& svg path": { stroke: "#fff" },
                    },
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: "26px" }}>
                  {item.icon}
                </ListItemIcon>
                <StyledListItemText primary={item.title} />
              </ListItemButton>
            </StyledListItem>
          ))}
        </Stack>
      </List>
    </Stack>
  );
};

export default CarePlanSideDrawer;
